export class SignUpResult {
    constructor() { }
}
SignUpResult.EmailTaken = new SignUpResult();
SignUpResult.Success = class extends SignUpResult {
    constructor(userId) {
        super();
        this.userId = userId;
    }
};
export var LoginResult;
(function (LoginResult) {
    LoginResult["Success"] = "success";
    LoginResult["UserNotFound"] = "user not found";
    LoginResult["WrongPassword"] = "wrong password";
    LoginResult["TooManyAttempts"] = "too many attempts";
})(LoginResult || (LoginResult = {}));
export var PasswordResetResult;
(function (PasswordResetResult) {
    PasswordResetResult["Success"] = "success";
    PasswordResetResult["InternalError"] = "internal-error";
})(PasswordResetResult || (PasswordResetResult = {}));
